import * as mediaFeature from "./feature/index.js";
import * as mediaList from "./list.js";
import * as modifier from "./modifier.js";
import * as mediaQuery from "./query.js";
import * as mediaType from "./type.js";
import * as value from "./feature/value/index.js";
/**
 * @public
 */
export var Media;
(function (Media) {
    Media.Feature = mediaFeature.Media;
    Media.List = mediaList.List;
    Media.Modifier = modifier.Modifier;
    Media.Query = mediaQuery.Query;
    Media.Type = mediaType.Type;
    Media.Value = value.Value;
    Media.type = Media.Type.of, Media.isType = Media.Type.isType;
    Media.isMedia = Media.Feature.isMedia;
    Media.query = Media.Query.of, Media.isQuery = Media.Query.isQuery;
    Media.list = Media.List.of, Media.isList = Media.List.isList;
    Media.parse = Media.List.parse;
})(Media || (Media = {}));
//# sourceMappingURL=index.js.map